export const propRules = {
  rules: {
    heading: "قواعد الإقامة",
    subheading:
      "حدّد أوقات الدخول والخروج التي ستُبلَّغ للنزيل أثناء تسجيل الوصول.",
    cloneTitleNoun: "المواعيد",
    cloneItemNoun: "المواعيد",
    bulkNoticePrefix:
      "سيُطبَّق هذا التغيير على {count} من الإقامات المرتبطة بـ",
    checkinLabel: "تسجيل الوصول",
    checkoutLabel: "تسجيل المغادرة",
    defaultCheckin: "افتراضيًا 15:00",
    defaultCheckout: "افتراضيًا 12:00",
    saving: "جارٍ الحفظ…",
    save: "حفظ",
    toasts: {
      loadError: "تعذّر تحميل بيانات الإعلان.",
      bulkApplied: "طُبِّقت القواعد على {count} من الإقامات",
      saveSuccess: "تم حفظ القواعد بنجاح",
      bulkPartialError: "تعذّر تحديث بعض الإقامات",
      saveError: "خطأ أثناء حفظ القواعد",
    },
  },
  services: {
    cloneTitleNoun: "التجهيزات ووسائل الراحة",
    cloneItemNoun: "التجهيزات ووسائل الراحة",
    toasts: {
      saveSuccess: "تم حفظ وسائل الراحة بنجاح",
      saveError: "خطأ أثناء حفظ وسائل الراحة",
    },
  },
  maintenance: {
    title: "صيانة الإقامة",
    scopeProperty: "الإقامة بالكامل",
    scopeUnits: "وحدات محددة",
    selectUnits: "اختر الوحدات",
    dateFrom: "من",
    dateTo: "إلى",
    closeArrivals: "إغلاق الوصول (CTA)",
    closeDepartures: "إغلاق المغادرة (CTD)",
    applying: "جارٍ التطبيق...",
    apply: "تطبيق الصيانة",
    removing: "جارٍ الإزالة...",
    remove: "إزالة الصيانة",
    toasts: {
      rangeScopeRequired: "أكمِل النطاق الزمني والنطاق (الوحدات أو الإقامة).",
      applied: "تم تطبيق الصيانة.",
      applyError: "خطأ أثناء تطبيق الصيانة.",
      removed: "تمت إزالة الصيانة.",
      removeError: "خطأ أثناء إزالة الصيانة.",
    },
  },
  propMaintenance: {
    title: "صيانة الإقامة",
    scopeProperty: "الإقامة بالكامل",
    scopeUnits: "وحدات محددة",
    selectUnits: "اختر الوحدات",
    dateFrom: "من",
    dateTo: "إلى",
    closeArrivals: "إغلاق الوصول (CTA)",
    closeDepartures: "إغلاق المغادرة (CTD)",
    applying: "جارٍ التطبيق...",
    apply: "تطبيق الصيانة",
    removing: "جارٍ الإزالة...",
    remove: "إزالة الصيانة",
    toasts: {
      rangeScopeRequired: "أكمِل النطاق الزمني والنطاق (الوحدات أو الإقامة).",
      applied: "تم تطبيق الصيانة.",
      applyError: "خطأ أثناء تطبيق الصيانة.",
      removed: "تمت إزالة الصيانة.",
      removeError: "خطأ أثناء إزالة الصيانة.",
    },
  },
};
